import React from 'react';
import moment from 'moment';
import { DateText, DateBorder, DisabledDate } from './styled';
import { getDateShortcuts, shouldHide } from '@src/utils/tz';

const Shortcuts = ({ selectedInterval, overviewDate, tzOffset, setDateCb }) => {
  const shortcuts = getDateShortcuts();

  const getShortcuts = () => {
    const elements = shortcuts.map(([shortcut, interval], index) => {
      const isDisabled = shouldHide(interval[0], overviewDate, tzOffset, shortcut);

      const onChangeOfShortcut = () => {
        const currentInterval = {
          from: moment(interval[0]).format(),
          to: moment(interval[1]).format(),
          shortcut,
        };

        // dispatch(setInterval({interval: currentInterval}));
        setDateCb(currentInterval);
      };

      if (isDisabled) {
        return (
          <React.Fragment key={index}>
            <DisabledDate>{shortcut}</DisabledDate>
            <DateBorder />
          </React.Fragment>
        );
      }

      const isSelected = selectedInterval.shortcut === shortcut;
      return (
        <React.Fragment key={index}>
          <DateText
            className={isSelected ? 'active' : ''}
            selected={isSelected}
            onClick={onChangeOfShortcut}
          >
            {shortcut}
          </DateText>
          <DateBorder />
        </React.Fragment>
      );
    });
    return elements;
  };

  return <>{getShortcuts()}</>;
};

export default Shortcuts;
